// These three requires are needed if you're using typeahead.
//require('./libs/typeahead.jquery');
//Bloodhound = require('./libs/bloodhound');
//Levenshtein = require('./libs/levenshtein');

/**
 * This is an example of how to modify the functionality of the FindAMember class.
 * You can copy this into your theme and use the pubsub event hooks to setup things like
 * event handlers, typeahead completions and search results title creation.
 */
jQuery(document).ready(function($) {

  // ----- Find a member subscriptions
  /**
   * Setup form typeaheads
   *
   * @dependecies: typeahead, bloodhound, fast-levenshtein
   */
  /*
  $.subscribe('find_a_member/setup_typeaheads', function () {

    // Global typeahead settings.
    const minLengthBeforeSearching = 1;
    const maxResults = 10;

	// On typeahead select: trigger the search form.
	let form$ = FindAMember.get_element('form');

    // Autocomplete company name search.
    let url = `${IUGO_FIND_A_MEMBER.ajaxUrl}?action=${IUGO_FIND_A_MEMBER.ajaxActionSearch}`
    let htmlInputName = 'company_name';
    let findAMemberRegisteredElement = 'searchCompany';
    FindAMember._elements[findAMemberRegisteredElement].typeahead(
        {hint: true, minLength: minLengthBeforeSearching},
        {name: htmlInputName, source: FindAMember.get_bloodhound_source(url, findAMemberRegisteredElement, maxResults)}
    );

	let companyName$ = FindAMember.get_element(findAMemberRegisteredElement);

	// Required to fix Agend theme styles breaking typeahead fields.
	companyName$.closest('.agendtheme-form-input').addClass('agendtheme-form-input--is-typeahead');
    companyName$.on('typeahead:select', function () {
      FindAMember.search();
    });

    // Autocomplete post_title title.
    let url = `${IUGO_FIND_A_MEMBER.ajaxUrl}?action=${IUGO_FIND_A_MEMBER.ajaxActionSearchPostTitle}`
    htmlInputName = 'search';
    findAMemberRegisteredElement = 'searchTitle';
    FindAMember._elements[findAMemberRegisteredElement].typeahead(
        {hint: true, minLength: minLengthBeforeSearching},
        {name: htmlInputName, source: FindAMember.get_bloodhound_source(url, findAMemberRegisteredElement, maxResults)}
    );

    let postTitle$ = FindAMember.get_element(findAMemberRegisteredElement);

    // On typeahead select: trigger the search form.
	postTitle$.closest('.agendtheme-form-input').addClass('agendtheme-form-input--is-typeahead');
    postTitle$.on('typeahead:select', function () {
      FindAMember.search();
    });

  });
  */

  /**
   * Setup slider
   * @dependencies: rangeslider
   */
  $.subscribe('find_a_member/setup_slider', function() {
    if (!FindAMember.are_maps_enabled()) {
      return;
    }
    var radiusValue$ = $('#radius-value');
    FindAMember._elements.slider.rangeslider({

      onSlideEnd: function (position, value) {
        FindAMember.search();
      },
      onSlide: function (position, value) {
        radiusValue$.text(value + ' km');
      }
    });
  });

  /**
   * Update search result title
   * @param json Data from search results
   * @param object Form values
   */
  $.subscribe('find_a_member/update_title', function (event$, searchResults, formValues) {
    let total = searchResults.total,
      search = formValues.search,
      memberText = (total == 1) ? 'result' : 'results',
      searchTerms = '';

    if (typeof search !== 'undefined' && search !== null) {
      searchTerms += 'for name "' + search + '" ';
    }

    if (FindAMember.are_maps_enabled()) {
      let location = searchResults.location,
        radius = searchResults.radius;

        if (typeof location.title !== 'undefined' && location.title !== null) {
          searchTerms += 'at "' + location.title + '"';
        }
        if (typeof radius !== 'undefined' && location.title !== '' && location.title !== null) {
          searchTerms += ' within ' + radius + ' km';
        }
    }

    let title = total + ' ' +  memberText + ' found ' + searchTerms;

    FindAMember.get_element('title').html(title);
  });

  /**
   * Setup page specific events
   */
  $.subscribe('find_a_member/handle_changes', function() {

    //On form submission run the search
    FindAMember.get_element('form').on('submit', function (e) {
      e.preventDefault();

      if (FindAMember._searching) {
        return;
      }

      if (!FindAMember.are_maps_enabled()) {
        FindAMember.search();
        return;
      }

      let locationSearch$ = FindAMember.get_element('locationSearch');
      $('#latitude').val('');
      $('#longitude').val('');

      let autocompleteEl = document.getElementById(FindAMember._elements.locationSearch.attr('id'));

      //Geocode the location if the user has not clicked on the result
      if (autocompleteEl && locationSearch$.val() !== '' && $(".pac-item-selected").length === 0) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': locationSearch$.val()}, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK && results[0]) {

            var lat = results[0].geometry.location.lat();
            var lng = results[0].geometry.location.lng();
            var formattedAddress = results[0].formatted_address;

            $('#geometry_latitude').val(lat);
            $('#geometry_longitude').val(lng);
            $('#administrative_area_level_1').val(formattedAddress);
            FindAMember.get_element('locationSearch').val(formattedAddress);
            FindAMember.search();
          }
        });
      } else {
        FindAMember.search();
      }
    });

    $('.js-action-clear').on('click', function(e) {
      e.preventDefault();

      // Reset Agend form inputs if they exist.
      let agendFormInputs$ = $('.agendtheme-form-input');
      agendFormInputs$.each(function () {
        $(this).removeClass('not-empty');
      });

      FindAMember.get_element('form').trigger('reset');
      FindAMember.search_all();
    });

    $('#use_my_location').on('click', function(e){
      e.preventDefault();
      locationSearch$.val('');
      FindAMember.use_my_current_location(true);
    });

  });

  function getScrollToYPosition() {
    let results$ = $('.results');
    if (results$.length) {
      return results$.offset().top;
    }

    return 0;
  }

  let elements = {
    form: 'form.form-find-a-member',
    listResults: '.list-results',
    modal: '#modal__find-a-member',
    pagination: '.search-results-pagination',
    title: '.search-results-title',
    locationSearch: '#search-location',
    slider: '#radius',
    buttonCurrentLocation: '#use_my_location'
    //searchTitle: '#search-title',
    //searchCompany: '#search-company'
  };

  let templates = {
    member: '#member-list-item',
    pagination: '#member-pagination',
    pinHtml: '#member-google-map-pin-html'
  };

  // Check if a class exists in the body tag.
  let areMapsEnabled = !$('body').hasClass('find-a-member-maps-disabled');

  let settings = {
    scroll_to_results: {
      enabled: true,
      scroll_to_y_position: getScrollToYPosition(),
      scroll_time_ms: 600
    },
    pagination: { item_count: 10 },
    member_title: 'results',
    maps_enabled: areMapsEnabled
  }

  // ----- Initialise Find a member
  FindAMember.init({
    templates: templates,
    elements: elements,
    settings: settings
  });

  // If maps are disabled: search all members and return as we won't have the google maps library.
  if (!FindAMember.are_maps_enabled()) {
    FindAMember.search_all();
    return;
  }

  // ----- Initialise GoogleMaps
  var mapFindMember$ = $('#map-find-a-member');

  var googleMapsOptions = {
    mapHolder: mapFindMember$,
    scrollDownControls: true,
    showHideControls: true,
    pinColourActive: '#4daaab',
    pinColourInactive: '#4daaab'
  };

  GoogleMaps.init(googleMapsOptions);

  //Wait for Google maps to finish loading, before performing a search
  $.subscribe('google-maps.initialised', function () {
    // If get params exist (browser back from detail page): trigger the search
    if ($('#search-location').val() !== '') {
      FindAMember.search();
    } else if (mapFindMember$.data('search-user-location')) {
      var shouldShowError = function(error) {
        //unexpected type of error data...
        if (!error || !error.code || !error.PERMISSION_DENIED) {
          return true;
        }

        if (error.code === error.PERMISSION_DENIED) {
          console.warn('User denied geolocation, will not auto-search based on location.');
          return false;
        }

        return true;
      }
      FindAMember.use_my_current_location(shouldShowError).fail(function () {
        FindAMember.search_all();
      });
    } else {
      FindAMember.search_all();
    }
  });

});
